<template>
    <div class="card-item" :style="{width:cardWidth}" >
        <div class="head">
            {{head}}
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        head:{
            type:String,
            default:""
        },
        width:{
            type:[String,Number],
            default:"204px"
        }
    },
    computed: {
        cardWidth() {
            if(!!this.width){
                let type = typeof(this.width);
                return type == 'string' ? this.width : `${this.width}px` 
            }else{
                return ""
            }
            
        }
    },
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
    .card-item {
        // background-color: #ffffff;
        float: left;
        
        .head {
            width: 100%;
            font-size: 14px;
            color: #c8c8c8;
            margin-bottom: 13px;
        }
        .content {
            box-sizing: border-box;
            width: 100%;
            font-size: 14px;
            color: #181919;
            font-weight: 600;
            padding-right: 10px;
        }
    }
</style>